import { useHistory } from "react-router-dom";
import PageRoute from "../../../constant/pageRouteDictionary.json";
import { useMessagingContext } from "../../../hooks/Messaging";
import MessagingContacts from "../../Messaging/Channels/MessagingContacts";

const ContactsWidget = () => {

  const history = useHistory();

  const { addConversation, addPendingConversation  } = useMessagingContext();

  const handleConversationAdded = ({ conversation }) => {
    if (addConversation(conversation)) {
      const { directMessageConversationId } = conversation;
      navigateToMessagingPage(directMessageConversationId);
    }
  };

  const handleAddConversationWithApproval = (member) => {
    const added = addPendingConversation(member);
    if (added) {
      navigateToMessagingPage(null); // or add `state: { pendingUserId: member.userId }` for UI filtering
    }
  }

  const navigateToMessagingPage = (conversationId) => {
    history.push({
      pathname: PageRoute["MESSAGING"],
      state: { conversationId }
    });
  };

  const navigateToMessagingPageWithPendingConversation = (pendingConversation) => {

    history.push({
      pathname: PageRoute["MESSAGING"],
      state: { pendingConversation }
    });
  }
  

  return (
    <MessagingContacts
      onConversationAdded={handleConversationAdded}
      onConversationSelected={navigateToMessagingPage}
      onAddConversationWithApproval={handleAddConversationWithApproval}
      onPendingConversationSelected={navigateToMessagingPageWithPendingConversation}
    />
  );
};

export default ContactsWidget;
